const nestedViewMixin = require('../../modules/views/nested_view');
const trackingUtils = require('../../modules/utils/tracking.utils');

const toggleSummaryVisibility = function(model, active) {
    this.getSelector('summaryContainer').toggleClass('odf-hidden', active);
};

module.exports = Backbone.View.extend(Odigeo._.defaults({
    events: {
        'change .filter_header': 'turnOn',
    },
    selectors: {
        summaryContainer: '.summary_container',
    },
    initialize: function(options) {
        this.views = {};
        this.model = options.model;
        this.templates = options.templates;
        this.name = options.name;
        if (options.$el) {
            this.$el = options.$el;
        }
        this.viewInjector = options.viewInjector(this);
        this.listenTo(this.model, 'change:active', toggleSummaryVisibility);
        Odigeo._.each(Odigeo._.range(options.numberOfTabs), Odigeo._.bind(function(tabIndex) {
            this.renderSummaryView(this.model.get('filterSummary').get(tabIndex));
        }, this));
    },
    turnOn: function() {
        const action = this.model.toggle() ? 'open' : 'close';
        if (this.name) {
            trackingUtils.trackEvent('results_filters', action + '_filters_' + this.name);
        }
        this.addSummarySeparatorToMultiTrip();
    },
    getSelector: function(selector) {
        return this.$el.find(this.selectors[selector]);
    },
    renderSummaryView: function(model) {
        const view = this.createView(model.id, this.viewInjector.create('appliedFiltersSummary', {
            model: model,
        }));
        view.render();
        this.getSelector('summaryContainer').append(view.$el);
    },
    addSummarySeparatorToMultiTrip: function() {
        const summariesContainersInFilter = this.el.querySelectorAll('.summary_label');
        summariesContainersInFilter.forEach((e, i) => {
            const isNextSummariesEmpty = [...summariesContainersInFilter].slice(i+1).some((e) => e.innerHTML !== '' );
            (e.innerHTML !== '' && isNextSummariesEmpty)
                ? e.classList.add('od-summary-label') : e.classList.remove('od-summary-label');
        });
    },
}, nestedViewMixin));
